import { v4 as uuid } from 'uuid'

export interface IPar {
  id: string
  restaurantCompanyId: string
  priceListEntryId: string
  quantity: number
  quantityType?: string,
  location?: string
}

export class Par implements IPar {
  public id: string = uuid()
  quantityType?: string

  constructor(
      public restaurantCompanyId: string,
      public priceListEntryId: string,
      public quantity: number,
      public location?: string
  ) {}
}
